type CioAnalytics = {
  identify: (userId: string, traits?: Record<string, unknown>) => void;
  group: (groupId: string, traits?: Record<string, unknown>) => void;
  track: (event: string, properties?: Record<string, unknown>) => void;
  page: (name?: string, properties?: Record<string, unknown>) => void;
  reset: () => void;
};

declare global {
  interface Window {
    cioanalytics?: CioAnalytics;
  }
}

function safeCall(fn: () => void, method: string) {
  try {
    fn();
  } catch (e) {
    console.error(`[marketing] ${method} failed`, e);
  }
}

/**
 * Marketing service - Customer.io wrapper
 * Used for lifecycle events, campaigns, and user engagement
 */
export const marketing = {
  identify(userId: string, traits?: Record<string, unknown>) {
    safeCall(() => window.cioanalytics?.identify(userId, traits), 'identify');
  },

  group(projectId: string, traits?: Record<string, unknown>) {
    safeCall(() => window.cioanalytics?.group(projectId, traits), 'group');
  },

  track(event: string, properties?: Record<string, unknown>) {
    safeCall(() => window.cioanalytics?.track(event, properties), 'track');
  },

  page(name?: string, properties?: Record<string, unknown>) {
    safeCall(() => window.cioanalytics?.page(name, properties), 'page');
  },

  reset() {
    safeCall(() => window.cioanalytics?.reset(), 'reset');
  },
};
